import * as React from 'react';

import classnames from 'classnames';

import {formatTimestampForScheduledMail} from 'nutshell-core/date-time/formatting';

import {DateTimePickerPopover} from 'shells/date-time-picker/date-time-picker-popover';
import {Label} from 'shells/form/label';

import type {CustomFieldValueInput} from 'nutshell-graphql-types';

import styles from './graphql-field-date.module.css';

type Props = {
    value: string | null | undefined; // ISO formatted date string,
    onChange: (newVal: CustomFieldValueInput) => void;
    label: string;
    fieldName: string;
    blinkSuccess: boolean;
};

export function GraphQLFieldDate(props: Props) {
    const dateField = React.useRef<HTMLElement | null | undefined>(null);
    const [showPopover, setShowPopover] = React.useState<boolean>(false);

    const styleName = classnames(styles['date-field-button'], {
        [styles.success]: props.blinkSuccess,
        [styles.placeholder]: !props.value,
    });

    return (
        <React.Fragment>
            <Label htmlFor={props.fieldName}>{props.label}</Label>
            <button
                id={props.fieldName}
                type='button'
                // @ts-expect-error
                ref={dateField}
                onClick={() => {
                    setShowPopover(true);
                }}
                className={styleName}
            >
                {props.value
                    ? formatTimestampForScheduledMail(new Date(props.value).getTime() / 1000)
                    : `Add ${props.fieldName}…`}
            </button>
            {dateField.current && showPopover ? (
                <DateTimePickerPopover
                    anchor={dateField.current}
                    value={props.value ? new Date(props.value) : new Date()}
                    shouldOmitTime={true}
                    onCancel={() => {
                        setShowPopover(false);
                    }}
                    onClear={
                        props.value
                            ? () => {
                                  props.onChange({date: null});
                                  setShowPopover(false);
                              }
                            : undefined
                    }
                    onConfirm={(newDate) => {
                        props.onChange({
                            date: newDate.toISOString(),
                        });
                        setShowPopover(false);
                    }}
                />
            ) : null}
        </React.Fragment>
    );
}
